export default __webpack_public_path__ + "static/media/gallery_01.81056bb0.jpg";